import { render, staticRenderFns } from "./BulkOrderDetails.vue?vue&type=template&id=147de834&scoped=true"
import script from "./BulkOrderDetails.vue?vue&type=script&lang=js"
export * from "./BulkOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./BulkOrderDetails.vue?vue&type=style&index=0&id=147de834&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147de834",
  null
  
)

export default component.exports